import { Component, OnInit } from "@angular/core";
import { DataService_Inbox } from "../report-inbox/shared/data.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { MenuService } from "../../master/services";

@Component({
	selector: "app-report-inbox-detail",
	templateUrl: "./report-inbox-detail.component.html",
	styleUrls: ["./report-inbox-detail.component.css"],
})
export class ReportInboxDetailComponent implements OnInit {
	constructor(
		private dataService: DataService_Inbox,
		private route: ActivatedRoute,
		private router: Router,
		private confirmationService: ConfirmationService,
		private menuService: MenuService
	) {}

	ngOnInit(): void {
		this.InboxID = Number(this.route.snapshot.paramMap.get("id"));

		this.loadReport();
	}

	////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////

	InboxID: number = -1;

	LoadingReport: boolean = true;

	JobDesc: string = "";
	Subject: string = "";
	Body: string = "";
	c_dateDesc: string = "";
	ResultsJson: string = "";

	lstTable: any = [];
	lstCols: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	errorMessage: string = "";

	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////

	loadReport() {
		this.LoadingReport = true;

		var result = this.dataService.InboxSelect(this.InboxID);
		result.subscribe(
			(response: any) => {
				if (response.InboxID <= 0) {
					this.onBack();
				}

				this.JobDesc = response.JobDesc;
				this.Subject = response.Subject;
				this.Body = response.Body;
				this.c_dateDesc = response.c_dateDesc;
				this.ResultsJson = response.ResultsJson;

				this.UpdateTable();

				this.menuService.reportInboxChanged("Refresh");
			},
			(error) => {
				this.LoadingReport = false;
			}
		);
	}

	UpdateTable() {
		if (this.ResultsJson != undefined && this.ResultsJson.length > 0) {
			try {
				this.lstTable = JSON.parse(this.ResultsJson);
				if (this.lstTable.length > 0) {
					this.lstCols = Object.keys(this.lstTable[0]);
				}

				console.log(this.lstTable);
				console.log(this.lstCols);
			} catch (e) {
				e.toString();
			}
		}

		this.LoadingReport = false;
	}

	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////

	onBack() {
		this.router.navigate(["inboxreport/inbox"]);
	}

	onDelete() {
		this.errorMessage = "";

		this.confirmationService.confirm({
			key: "inboxconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this report?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.LoadingReport = true;

		var result = this.dataService.InboxDelete(this.InboxID);
		result.subscribe(
			(response: any) => {
				this.LoadingReport = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Report was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.router.navigate(["inboxreport/inbox"]);
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.LoadingReport = false;
			}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		for (var z = 0; z < this.lstCols.length; z++) {
			var next = this.lstCols[z];
			DataStr += `"` + next + `",`;
		}
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstTable.length; z++) {
			var next = this.lstTable[z];

			for (var c = 0; c < this.lstCols.length; c++) {
				var nextCol = this.lstCols[c];
				var nextData = next[nextCol];

				DataStr += `"` + nextData + `",`;
			}

			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>
		var FileName = "Export_" + this.ReplaceInvalidChars(this.JobDesc);

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	ReplaceInvalidChars(str: string) {
		str = this.ReplaceAllOccur(str, "<", "");
		str = this.ReplaceAllOccur(str, ">", "");
		str = this.ReplaceAllOccur(str, ":", "");
		str = this.ReplaceAllOccur(str, '"', "");
		str = this.ReplaceAllOccur(str, "/", "");
		str = this.ReplaceAllOccur(str, "\\", "");
		str = this.ReplaceAllOccur(str, "|", "");
		str = this.ReplaceAllOccur(str, "?", "");
		str = this.ReplaceAllOccur(str, "*", "");
		str = this.ReplaceAllOccur(str, " ", "_");
		str = this.ReplaceAllOccur(str, ",", "_");

		return str;
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	////////////////////////////////////////////////////////////////////
}
